import styled from "styled-components";

export const StyledCheckoutFormQuestionWrapper = styled.div`
  padding: 1.6rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  position: relative;
  /* z-index: 0; */
  background-color: #fff;
`;
export const StyledCheckoutFormQuestionHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
  align-items: center;
  .header-text {
    font-size: 1.4rem;
    font-weight: 400;
  }
`;
export const StyledCheckoutFormQuestionInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
  align-items: center;

  .input-wrapper {
    width: 100%;
  }
  .button-wrapper {
    display: flex;
    gap: 1rem;
  }
`;
